import { Injectable } from '@angular/core';
import { UserDevice } from '@features/users/models/user-device.model';
import * as uuid from 'uuid';
import { ConfigConstant } from '@shared/constants/config.constant';
import { Mapper } from './base-mapper.service';
import { StorageConstant } from '@shared/constants/storage.constant';
import { LanguageService } from './language.service';
import { LanguageEnum } from '@shared/enums/global.enum';

@Injectable({
  providedIn: 'root',
})
export class UserDeviceService {
  constructor(private mapper: Mapper, private languageService: LanguageService) {}

  saveUserDevice(userDevice: UserDevice) {
    if (userDevice) {
      try {
        localStorage.setItem(StorageConstant.USER_DEVICE_KEY, userDevice.toJson());
      } catch (e) {
        console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
      }
    }
  }

  //TODO: implement a new way to generate device id to be more reliable
  getCurrentUserDevice(): UserDevice {
    let json: string | null = null;
    try {
      json = localStorage.getItem(StorageConstant.USER_DEVICE_KEY);
    } catch (e) {
      console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
      return null;
    }
    return json ? this.mapper.fromJson(UserDevice, JSON.parse(json)) : null;
  }

  generateNewDevice(): UserDevice {
    const userDevice = new UserDevice();
    userDevice.deviceId = uuid.v4();
    userDevice.appVersion = ConfigConstant.VERSION;
    userDevice.osVersion = navigator.platform;
    userDevice.deviceModel = navigator.appVersion;
    userDevice.languageIsoCode = this.currentLanguageIsoCode();

    return userDevice;
  }

  // The language pushes are sent in; Arabic when none is resolved.
  currentLanguageIsoCode(): string {
    return this.languageService.currentLanguage$.value?.isoCode || LanguageEnum.Arabic;
  }
}
